// extracted by mini-css-extract-plugin
module.exports = {"retCollBranch":"RetCollBranch_retCollBranch__LIaVm"};